


















































import Vue from 'vue';

import ColorPicker from '@reciprocity/color-picker';
import { components, methods, props } from './common';

export default Vue.extend({
  name: 'HeaderAppearance',
  components: {
    ...components,
    ColorPicker,
  },
  props,
  methods,
});
